import { API_ROUTES } from '@/constants/apiRoutes';
import { ApiResponse, PaginatedApiResponse } from '@/react-query/context/ApiClientContextController';
import { queryFactoryOptions } from '@/react-query/utills/queryFactoryOptions';
import { AxiosInstance } from 'axios';
import { CustomerWithdrawal } from './customerWithdrawals.types';
import { StatusType, WithdrawalParams } from './withdrawals.types';

export const getCustomerWithdrawals = (client: AxiosInstance) => async (params?: WithdrawalParams) => {
  return (
    await client.get<PaginatedApiResponse<CustomerWithdrawal[]>>(API_ROUTES.GET_CUSTOMER_WITHDRAWAL_LIST, { params })
  ).data;
};

export const getCustomerWithdrawalDetail = (client: AxiosInstance) => async (withdrawalId?: string) => {
  return (
    await client.get<ApiResponse<CustomerWithdrawal>>(API_ROUTES.GET_CUSTOMER_WITHDRAWAL_DETAIL, {
      params: { withdrawalId: withdrawalId || '' },
    })
  ).data;
};

export const customerWithdrawalsQueries = {
  all: () => ['customerWithdrawals'],
  list: (type: StatusType, params?: WithdrawalParams) =>
    queryFactoryOptions<PaginatedApiResponse<CustomerWithdrawal[]>>({
      queryKey: [...customerWithdrawalsQueries.all(), 'list', type, params],
      queryFn: (client: AxiosInstance) => () => getCustomerWithdrawals(client)(params),
    }),
  detail: (withdrawalId?: string) =>
    queryFactoryOptions<ApiResponse<CustomerWithdrawal>>({
      queryKey: [...customerWithdrawalsQueries.all(), 'detail', withdrawalId],
      queryFn: (client: AxiosInstance) => () => getCustomerWithdrawalDetail(client)(withdrawalId),
    }),
};
